"use client";

import Button from "../../../../../shared/components/ui/Button";
import useBulkUpdateProgramsSchedule from "../../../../academyProgramDetail/hooks/schedule/useBulkUpdateProgramsSchedule";
import { ProgramScheduleType } from "../../../../../types/dto/program";
import BulkEditProgramSchedulePricesForm from "./BulkEditProgramSchedulePricesForm";
import { formatScheduleMonth } from "../../../../academyProgramDetail/utils/scheduleDateUtils";

export interface BulkEditProgramScheduleProps {
  programSchedules: ProgramScheduleType[];
  setOpenModal: (value: boolean) => void;
  onSuccess?: () => void;
}

export default function BulkEditProgramSchedule({
  programSchedules,
  setOpenModal,
  onSuccess,
}: BulkEditProgramScheduleProps) {
  const { control, loading, handleSubmit } = useBulkUpdateProgramsSchedule({
    programSchedules,
    setOpenModal,
    onSuccess,
  });

  return (
    <form onSubmit={handleSubmit}>
      <p className="mb-3 text-sm text-gray-600">
        Se actualizarán {programSchedules.length} meses seleccionados:
      </p>
      <ul className="mb-4 max-h-32 list-disc overflow-y-auto pl-5 text-sm capitalize">
        {programSchedules.map((schedule) => (
          <li key={schedule.id}>
            {formatScheduleMonth(
              schedule.month,
              schedule.day_of_month_payment_limit
            )}
          </li>
        ))}
      </ul>
      <BulkEditProgramSchedulePricesForm control={control} />
      <div className="mt-4 flex items-center justify-end">
        <Button
          primary
          className="bg-[#072082]"
          loading={loading}
          type="submit"
          variant="filled"
        >
          Actualizar montos
        </Button>
      </div>
    </form>
  );
}
